import React from "react";
import { motion } from "framer-motion";
import { FlameIcon, LockIcon } from "lucide-react";
import { useOffer } from "../../contexts/OfferContext";
import { FUTURE_PRICE, PRICE_TODAY } from "../../data/offer";
export function StockBar() {
  const {
    stock,
    soldPercent
  } = useOffer();
  return <div className="rounded-2xl border border-white/10 bg-white/5 p-4" data-id="element-611" data-mp="1v1t7lt3n6uhz">
      <div className="flex items-center justify-between gap-3 text-sm" data-id="element-612" data-mp="1qzoeqwl0q1we">
        <p className="flex items-center gap-1.5 font-semibold text-cream" data-id="element-613" data-mp="1r0zkh1y0xjq5">
          <FlameIcon className="h-4 w-4 text-berry" data-id="element-614" data-mp="1lzsb4yg8gchd" />
          Solo quedan{" "}
          <motion.span key={stock} initial={{
          scale: 1.5,
          color: "#FF6B8F"
        }} animate={{
          scale: 1,
          color: "#E8C987"
        }} transition={{
          duration: 0.3
        }} className="inline-block text-lg font-extrabold tabular" data-id="element-615" data-mp="1h0p5bbsfi28c">
            {stock}
          </motion.span>{" "}
          descargas
        </p>
        <span className="text-xs font-semibold text-cream/60 tabular" data-id="element-616" data-mp="36elvutx850ta">{soldPercent}% vendido</span>
      </div>
      <div className="mt-3 flex items-center gap-3" data-id="element-617" data-mp="cc1okkwdvx7h">
        <span className="rounded-md bg-gold-light px-2 py-1 text-xs font-extrabold text-cocoa-dark" data-id="element-618" data-mp="cctat543cil3">${PRICE_TODAY}</span>
        <div className="relative h-4 flex-1 overflow-hidden rounded-full bg-black/30 ring-1 ring-white/10" data-id="element-619" data-mp="3tm9h8tfy833f">
          <motion.div className="bg-stripes animate-stripes h-full rounded-full bg-berry" initial={{
          width: 0
        }} animate={{
          width: `${soldPercent}%`
        }} transition={{
          duration: 0.3,
          ease: "easeOut"
        }} data-id="element-620" data-mp="2fov9o4r3ld9" />
        </div>
        <span className="flex items-center gap-1 rounded-md bg-white/10 px-2 py-1 text-xs font-bold text-cream/45" data-id="element-621" data-mp="gd3nf0me278x">
          <LockIcon className="h-3 w-3" data-id="element-622" data-mp="lan221n00m1e" />${FUTURE_PRICE}
        </span>
      </div>
      <p className="mt-2 text-xs text-cream/55" data-id="element-623" data-mp="190r78dfu4tui">Cuando la barra se llene, el precio sube a ${FUTURE_PRICE}.</p>
    </div>;
}